import { createSelector } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';

interface IState {
  search: string;
  provider: string;
  themes: any[];
  orders: any[];
  shipping: any;
  products: any[];
  categories: any[];
  productDetail: any;
  exChangeRate: number;
}
export const EcommerceHook = () => {
  const selectEcommerce = (state: RootState) => state.Ecommerce;
  const ecommerceProperties = createSelector([selectEcommerce], (e) => ({
    search: e.search,
    themes: e.themes,
    orders: e.orders,
    provider: e.provider,
    shipping: e.shipping,
    products: e.products,
    categories: e.categories,
    productDetail: e.productDetail,
    exChangeRate: e.exChangeRate,
  }));

  const {
    search,
    provider,
    orders,
    products,
    themes,
    categories,
    productDetail,
    exChangeRate,
    shipping
  } = useSelector(ecommerceProperties);

  const [state, setState] = useState<IState>({
    search,
    provider,
    orders,
    themes,
    products,
    categories,
    productDetail,
    exChangeRate,
    shipping
  });

  useEffect(() => {
    setState((v) => ({ ...v, search }));
  }, [search]);

  useEffect(() => {
    setState((v) => ({ ...v, provider }));
  }, [provider]);

  useEffect(() => {
    setState((v) => ({ ...v, orders }));
  }, [orders]);

  useEffect(() => {
    setState((v) => ({ ...v, categories }));
  }, [categories]);

  useEffect(() => {
    setState((v) => ({ ...v, themes }));
  }, [themes]);

  useEffect(() => {
    setState((v) => ({ ...v, productDetail }));
  }, [productDetail]);

  useEffect(() => {
    setState((v) => ({ ...v, products }));
  }, [products]);

  useEffect(() => {
    setState((v) => ({ ...v, exChangeRate }));
  }, [exChangeRate]);

  useEffect(() => {
    setState((v) => ({ ...v, shipping }));
  }, [shipping]);

  return state;
};
